module.exports = __webpack_public_path__ + "static/media/minusRound.8f3a2eb3.svg";